export default __webpack_public_path__ + "static/herobg-c9ace30c8d9cabdc00b67bc9ff46eb61.png";